import { Navigate } from 'react-router-dom';
import { useSurfaces } from '@/hooks/useSurfaces';

// Role-aware landing for the index route `/` (SENSARRA-VERTICAL-TENANT-SURFACE-1).
// A customer (tenant) lands on Research; operators/Director land on the dashboard.
// Waits for the authoritative snapshot to settle so an operator is not sent to the
// customer home first — but on error the fail-closed fallback still resolves.
export function RoleHomeRedirect() {
  const { homePath, settled } = useSurfaces();

  if (!settled) {
    return (
      <div className="flex h-full min-h-[40vh] items-center justify-center text-sm text-gray-400">
        Loading…
      </div>
    );
  }

  return <Navigate to={homePath} replace />;
}
